
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("buOGu", function(module, exports) {

$parcel$export(module.exports, "SmartRequestSummaryTrigger", () => $4dc3ccd38a1e62c1$export$248bd4abd6d78930);

var $5uXOq = parcelRequire("5uXOq");

var $d6u6P = parcelRequire("d6u6P");

var $iaqCW = parcelRequire("iaqCW");
const $4dc3ccd38a1e62c1$export$248bd4abd6d78930 = ({ props: { triggerRef: triggerRef, ...props } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d6u6P.SummaryStateContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iaqCW.Trigger), {
        ...props,
        ref: triggerRef
    }));

});
parcelRegister("iaqCW", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $ba6a448cbf5e6729$export$41fb9f06171c75f4);

var $5uXOq = parcelRequire("5uXOq");

var $bWn3s = parcelRequire("bWn3s");

var $2rqOp = parcelRequire("2rqOp");

var $42CjB = parcelRequire("42CjB");

var $jps85 = parcelRequire("jps85");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");


var $37XBA = parcelRequire("37XBA");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $lGvJS = parcelRequire("lGvJS");

var $iixvy = parcelRequire("iixvy");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $93Yeu = parcelRequire("93Yeu");

var $dCm1o = parcelRequire("dCm1o");

var $jllls = parcelRequire("jllls");
const $ba6a448cbf5e6729$export$e1ad8cf854a2228d = 'smartSummaryButton';
const $ba6a448cbf5e6729$export$41fb9f06171c75f4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ totalComments: totalComments, isCompact: isCompact }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const edition = (0, $93Yeu.useEdition)(projectKey, true);
    const isFeatureEnabled = isPremium && isAiOptInEnabled;
    const [isGenerating] = (0, $lGvJS.useIsGenerating)();
    const { loadSummaryStream: loadSummaryStream } = (0, $lGvJS.useActions)();
    const [hasClickSummaryPanelCloseButton] = (0, $lGvJS.useHasClickSummaryPanelCloseButton)();
    const triggerRef = (0, $5uXOq.useRef)(null);
    const mergedRef = (0, $bWn3s.mergeRefs)([
        ref,
        triggerRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('jfp_a11y_issue_comments_summary_panel_focus')) return;
        if (hasClickSummaryPanelCloseButton) triggerRef?.current?.focus();
    }, [
        hasClickSummaryPanelCloseButton
    ]);
    if (!isFeatureEnabled) return null;
    const onSummarizeButtonClick = (analyticsEvent)=>{
        loadSummaryStream();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jiraSmartSummarizeComments', {
            numberOfComments: totalComments
        });
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'aiInteraction initiated', {
            aiFeatureName: 'jiraSmartSummarizeComments',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1,
            edition: edition,
            invokedFrom: $ba6a448cbf5e6729$export$e1ad8cf854a2228d
        });
    };
    const renderVisualRefreshIconButton = ()=>{
        if (totalComments === 0) // If button is disabled, we don't want to render it as per BLU-5378
        return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ref: (0, $4R6GH.fg)('jfp_a11y_issue_comments_summary_panel_focus') ? mergedRef : ref,
            appearance: "subtle",
            spacing: "compact",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jps85))), {
                    color: "currentColor",
                    label: (0, $a56b51abbcbea207$export$1a33ff8e70228fd6)
                }),
            isDisabled: totalComments === 0,
            isLoading: isGenerating,
            testId: "issue-smart-request-summary-trigger.ui.jira-smart-summary-standard-button",
            onClick: (event, analyticsEvent)=>{
                onSummarizeButtonClick(analyticsEvent);
            },
            label: formatMessage((0, $jllls.default).summarize),
            interactionName: "ai-smart-summaries.ui.issue-button"
        });
    };
    const A11YWrapped = (0, $4R6GH.fg)('jfp_a11y_team_issue_modal_non_modal_dialog_update') ? (0, $dC5iT.default) : (0, $5uXOq.Fragment);
    const StandardSummaryButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage(isCompact ? (0, $jllls.default).compactTooltip : (0, $jllls.default).tooltip)
    }, (totalComments || 0) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireTrackAnalytics)(event, 'jiraSmartSummarizeComments mounted')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(A11YWrapped, (0, $4R6GH.fg)('jfp_a11y_team_issue_modal_non_modal_dialog_update') && {
        role: 'dialog',
        'aria-modal': 'false',
        'aria-label': formatMessage((0, $jllls.default).summarize)
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? renderVisualRefreshIconButton() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
        ref: (0, $4R6GH.fg)('jfp_a11y_issue_comments_summary_panel_focus') ? mergedRef : ref,
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $37XBA.AiIcon), {
            isDisabled: totalComments === 0,
            label: (0, $a56b51abbcbea207$export$1a33ff8e70228fd6),
            size: "small"
        }),
        isDisabled: totalComments === 0,
        isLoading: isGenerating,
        testId: "issue-smart-request-summary-trigger.ui.jira-smart-summary-standard-button",
        onClick: (event, analyticsEvent)=>{
            onSummarizeButtonClick(analyticsEvent);
        },
        interactionName: "ai-smart-summaries.ui.issue-button"
    }, !isCompact && formatMessage((0, $jllls.default).summarize))));
    return StandardSummaryButton;
});

});
const $a56b51abbcbea207$export$1a33ff8e70228fd6 = 'Atlassian Intelligence';
const $a56b51abbcbea207$export$9c7ce577b80c2668 = 8;
const $a56b51abbcbea207$export$d0d4ed81e1ed42ec = 6;
const $a56b51abbcbea207$export$b6e7a25078ed1a5f = 7;
const $a56b51abbcbea207$export$d0f488901b85b750 = 'LIKE';
const $a56b51abbcbea207$export$7ca6708a8b83d828 = 'DISLIKE';
const $a56b51abbcbea207$export$af6d68522cb370b8 = 'https://support.atlassian.com/organization-administration/docs/get-started-with-atlassian-intelligence/';

parcelRegister("jllls", function(module, exports) {

$parcel$export(module.exports, "default", () => $030f853ccb1dc89c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $030f853ccb1dc89c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    summarize: {
        "id": "issue-smart-request-summary-trigger.summarize",
        "defaultMessage": "Summarize"
    },
    tooltip: {
        "id": "issue-smart-request-summary-trigger.tooltip",
        "defaultMessage": "Get AI to summarize the comments, using the summary and description for context."
    },
    compactTooltip: {
        "id": "issue-smart-request-summary-trigger.compact-tooltip",
        "defaultMessage": "Summarize the comments."
    }
});

});




//# sourceMappingURL=async-issue-smart-request-summary-trigger.f36f3004.js.map
